import columns from '../../../../../react-table/helpers/columns';

export const predesResdesConditionalProps = (key, highlight) => {
  const predesKey = `predes.${key}`;
  const resdesKey = `resdes.${key}`;
  return (state, rowInfo) => {
    let className =
      rowInfo &&
      rowInfo.row[predesKey] &&
      rowInfo.row[resdesKey] &&
      rowInfo.row[predesKey] !== rowInfo.row[resdesKey] ? 'text-red' : '';
    className += highlight ? ' bg-gray-alabaster' : '';
    className = className.trim();
    return { className };
  };
};

export default (data) => {
  const {
    TextColumn,
    NonZeroTextColumn,
    NonZeroFloatColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId')
          .withWidth(275)),
        new DateTimeColumn('Despatch closed', 'despatchCloseDate')
          .withWidth(150),
        new DateTimeColumn('RESDES event date', 'resdesEventDate')
          .withWidth(150),
      ],
    },
    {
      Header: 'Receptacle type',
      columns: [
        new TextColumn('PREDES', 'predes.receptacleType')
          .withGetProps(predesResdesConditionalProps('receptacleType', true)),
        new TextColumn('RESDES', 'resdes.receptacleType')
          .withGetProps(predesResdesConditionalProps('receptacleType', false)),
      ],
    },
    {
      Header: 'Mail class',
      columns: [
        new TextColumn('PREDES', 'predes.mailClass')
          .withGetProps(predesResdesConditionalProps('mailClass', true)),
        new TextColumn('RESDES', 'resdes.mailClass')
          .withGetProps(predesResdesConditionalProps('mailClass', false)),
      ],
    },
    {
      Header: 'Documents included',
      columns: [
        new TextColumn('PREDES', 'predes.documentsIncluded')
          .withGetProps(predesResdesConditionalProps('documentsIncluded', true)),
        new TextColumn('RESDES', 'resdes.documentsIncluded')
          .withGetProps(predesResdesConditionalProps('documentsIncluded', false)),
      ],
    },
    {
      Header: 'Dangerous goods',
      columns: [
        new TextColumn('PREDES', 'predes.dangerousGoods')
          .withGetProps(predesResdesConditionalProps('dangerousGoods', true)),
        new TextColumn('RESDES', 'resdes.dangerousGoods')
          .withGetProps(predesResdesConditionalProps('dangerousGoods', false)),
      ],
    },
    {
      Header: 'Format of contents',
      columns: [
        new NonZeroTextColumn('PREDES', 'predes.formatOfContents')
          .withGetProps(predesResdesConditionalProps('formatOfContents', true)),
        new NonZeroTextColumn('RESDES', 'resdes.formatOfContents')
          .withGetProps(predesResdesConditionalProps('formatOfContents', false)),
      ],
    },
    {
      Header: 'Handling class',
      columns: [
        new TextColumn('PREDES', 'predes.handlingClass')
          .withGetProps(predesResdesConditionalProps('handlingClass', true)),
        new TextColumn('RESDES', 'resdes.handlingClass')
          .withGetProps(predesResdesConditionalProps('handlingClass', false)),
      ],
    },
    {
      Header: 'Tracked',
      columns: [
        new TextColumn('PREDES', 'predes.tracked')
          .withGetProps(predesResdesConditionalProps('tracked', true)),
        new TextColumn('RESDES', 'resdes.tracked')
          .withGetProps(predesResdesConditionalProps('tracked', false)),
      ],
    },
    {
      Header: 'Exempt',
      columns: [
        new TextColumn('PREDES', 'predes.exempt')
          .withGetProps(predesResdesConditionalProps('exempt', true)),
        new TextColumn('RESDES', 'resdes.exempt')
          .withGetProps(predesResdesConditionalProps('exempt', false)),
      ],
    },
    {
      Header: 'Weight',
      columns: [
        new NonZeroFloatColumn('PREDES', 'predes.weight')
          .withGetProps(predesResdesConditionalProps('weight', true)),
        new NonZeroFloatColumn('RESDES', 'resdes.weight')
          .withGetProps(predesResdesConditionalProps('weight', false)),
      ],
    },
    {
      Header: 'Weight type',
      columns: [
        new TextColumn('PREDES', 'predes.weightType')
          .withGetProps(predesResdesConditionalProps('weightType', true)),
        new TextColumn('RESDES', 'resdes.weightType')
          .withGetProps(predesResdesConditionalProps('weightType', false)),
      ],
    },
    {
      Header: 'Items',
      columns: [
        new NonZeroNumberColumn('PREDES', 'predes.items')
          .withGetProps(predesResdesConditionalProps('items', true)),
        new NonZeroNumberColumn('RESDES', 'resdes.items')
          .withGetProps(predesResdesConditionalProps('items', false)),
      ],
    },
    {
      Header: 'Non-returned',
      columns: [
        new TextColumn('PREDES', 'predes.nonReturned')
          .withGetProps(predesResdesConditionalProps('nonReturned', true)),
        new TextColumn('RESDES', 'resdes.nonReturned')
          .withGetProps(predesResdesConditionalProps('nonReturned', false)),
      ],
    },
    {
      Header: 'Returned',
      columns: [
        new TextColumn('PREDES', 'predes.returned')
          .withGetProps(predesResdesConditionalProps('returned', true)),
        new TextColumn('RESDES', 'resdes.returned')
          .withGetProps(predesResdesConditionalProps('returned', false)),
      ],
    },
  ];
};
